import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box } from '~/commonComponents/Box';
import { Row } from '~/commonComponents/Row';
import { FilterStatusEnum, FilterStatusLabel } from '~/utils/Enum';

export const CalendarLegends = () => (
  <Row paddingHorizontal={16} paddingVertical={14} alignItems="center" gap={12}>
    <Typography as="span" variant="body1" bold>
      Shift Legend:
    </Typography>
    <Row gap={12}>
      {[
        { value: FilterStatusEnum.TODAY, color: colors.primary[500] },
        { value: FilterStatusEnum.PENDING_COUNTER, color: colors.error[450] },
        { value: FilterStatusEnum.SCHEDULED, color: colors.secondary[500] },
        { value: FilterStatusEnum.OPEN, color: colors.success[500] },
        { value: FilterStatusEnum.COMPLETED, color: colors.neutral[300] },
        { value: FilterStatusEnum.CANCELLED_OR_EXPIRED, color: colors.warning[700] },
      ].map(({ value, color }) => {
        const label = FilterStatusLabel[value];
        return (
          <Row key={value} marginLeft={10} alignItems="center" gap={8}>
            <Box backgroundColor={color} borderRadius="100%" height={14} width={14} />
            <Typography as="span" color={colors.neutral[500]} variant="body1" style={{ lineHeight: '16px' }}>
              {label}
            </Typography>
          </Row>
        );
      })}
    </Row>
  </Row>
);
